"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsRecord = exports.FieldMap = exports.TsTable = exports.TsHeader = void 0;
class TsHeader {
    constructor(obj) {
        if (obj) {
            if (obj.name) {
                this.name = obj.name;
            }
            if (obj.type) {
                this.type = obj.type;
            }
            if (obj.decimalChar) {
                this.decimalChar = obj.decimalChar;
            }
            if (obj.isEnum) {
                this.isEnum = obj.isEnum;
            }
        }
    }
}
exports.TsHeader = TsHeader;
class TsTable {
    constructor(obj) {
        if (obj) {
            if (obj.headers) {
                this.headers = JSON.parse(JSON.stringify(obj.headers));
            }
            if (obj.data) {
                this.data = new Array();
                obj.data.forEach(data => {
                    var _a;
                    (_a = this.data) === null || _a === void 0 ? void 0 : _a.push(JSON.parse(JSON.stringify(data)));
                });
            }
            if (obj.defaultPricingField) {
                this.defaultPricingField = obj.defaultPricingField;
            }
            if (obj.qos !== null && obj.qos !== undefined) {
                this.qos = obj.qos;
            }
            if (obj.status) {
                this.status = obj.status;
            }
        }
    }
}
exports.TsTable = TsTable;
class FieldMap {
    constructor(obj) {
        if (obj) {
            if (obj.ertFields) {
                this.ertFields = obj.ertFields;
            }
            if (obj.summarizedFields) {
                this.summarizedFields = obj.summarizedFields;
            }
            if (obj.originalSummarizedFieldNames) {
                this.originalSummarizedFieldNames = obj.originalSummarizedFieldNames;
            }
        }
    }
    getSummarizedFieldName(ertFieldIndex) {
        if (this.originalSummarizedFieldNames) {
            return this.originalSummarizedFieldNames[ertFieldIndex];
        }
        return this.summarizedFields[ertFieldIndex].name || '';
    }
}
exports.FieldMap = FieldMap;
class TsRecord {
    constructor(obj) {
        if (obj) {
            this.annotation = obj.annotation;
            this.clauseNumber = obj.clauseNumber;
            this.keys = obj.keys || new Map();
            this.qualifierFacts = obj.qualifierFacts;
            this.recordType = obj.recordType;
            this.tag = obj.tag;
            this.timestamp = obj.timestamp;
            this.type = obj.type;
            this.sequenceNumber = obj.sequenceNumber;
            this.values = obj.values;
            this.fieldAssignments = obj.fieldAssignments;
            this.isImage = obj.isImage;
        }
    }
    clone() {
        const newTsRecord = new TsRecord();
        newTsRecord.annotation = this.annotation;
        newTsRecord.clauseNumber = this.clauseNumber;
        newTsRecord.keys = new Map(this.keys);
        newTsRecord.qualifierFacts = this.qualifierFacts ? [...this.qualifierFacts] : [];
        newTsRecord.recordType = this.recordType;
        newTsRecord.tag = this.tag;
        newTsRecord.timestamp = new Date(this.timestamp);
        newTsRecord.type = this.type;
        newTsRecord.sequenceNumber = this.sequenceNumber;
        newTsRecord.values = this.values ? [...this.values] : [];
        newTsRecord.fieldAssignments = this.fieldAssignments ? [...this.fieldAssignments] : [];
        newTsRecord.isImage = this.isImage;
        return this;
    }
}
exports.TsRecord = TsRecord;
